<template>
    <v-container>
        <!--     Diálogo Modal Persistente para Recortar Logotipo del Colegio      -->
        <v-dialog v-model="dialogImageLogo" persistent scrollable max-width="800px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        {{$t('recortar_imagen')}}
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <clipper-fixed
                            mode="normal"
                            class="basic lg"
                            ref="clipperImageLogo"
                            :src="imageLogoURL">
                    </clipper-fixed>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-col>
                        <v-row xs12 class="justify-center">
                            <v-btn
                                    color="primary"
                                    @click="getCutingLogo()"
                            >{{$t('recortar')}}</v-btn>
                        </v-row>
                    </v-col>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--     Diálogo Modal Persistente para Recortar Logotipo del Kinder      -->
        <v-dialog v-model="dialogImageLogoKinder" persistent scrollable max-width="800px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        {{$t('recortar_imagen')}}
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <clipper-fixed
                            mode="normal"
                            class="basic lg"
                            ref="clipperImageLogoKinder"
                            :src="imageLogoKinderURL">
                    </clipper-fixed>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-col>
                        <v-row xs12 class="justify-center">
                            <v-btn
                                    color="primary"
                                    @click="getCutingLogoKinder()"
                            >{{$t('recortar')}}</v-btn>
                        </v-row>
                    </v-col>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--     Diálogo Modal Persistente para Recortar Wallpaper Colegio      -->
        <v-dialog v-model="dialogImageWallpaper" persistent max-width="1000px">
            <v-card>
                <v-card-title>
                    <span class="headline">{{$t('recortar_imagen')}}</span>
                </v-card-title>
                <v-card-actions>
                    <v-btn
                            color="primary"
                            @click="getCutingWallpaper()"
                    >{{$t('recortar')}}</v-btn>
                </v-card-actions>
                <v-card-text>
                    <v-container>
                        <div class="flex">
                            <clipper-basic
                                    mode="normal"
                                    class="basic lg"
                                    ref="clipperImageWallpaper"
                                    :src="imageWallpaperURL">
                            </clipper-basic>
                        </div>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>
        <h2>{{$t('configuracion')}}</h2>
        <v-layout v-show="profileData.role === 3" align-center justify-center fill-height>
            <v-card width="500" align="center">
                <v-toolbar class="mb-5" dark color="primary">
                    <v-toolbar-title>
                        {{ $t('exit_code')}}
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                  <v-flex xs12>
                    <v-img
                        class="pt-3 pb-3"
                        :src="'https://api.qrserver.com/v1/create-qr-code/?data=' + profileData.qr_code + '&ecc=M&margin=20&size=400x400'"
                        width="250"
                        height="250"
                    ></v-img>
                  </v-flex>
                  <br>
                  {{$t('msg_exit_code')}}
                </v-card-text>
            </v-card>
        </v-layout>
        <br>
        <v-layout align-center justify-center fill-height>
            <v-card width="500">
                <v-toolbar class="mb-5" dark color="primary">
                    <v-toolbar-title>
                        {{ $t('cambiar_contrasena')}}
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <form @submit.prevent="changePassword()">
                        <v-text-field
                                v-model="currentPassword"
                                name="currentPassword"
                                prepend-icon="mdi-lock"
                                :label="$t('current_password')"
                                :type="show ? 'text' : 'password'"
                                :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                                @click:append="show = !show"
                                :error-messages="errores.current_password"
                                autocomplete="current-password"
                        ></v-text-field>
                        <ValidationObserver v-slot="{ invalid }" ref="observer">
                            <ValidationProvider :rules="'required|password:@confirm'" v-slot="{ errors }">
                                <v-text-field
                                        v-model="password"
                                        name="password"
                                        prepend-icon="mdi-lock"
                                        :label="$t('new_password')"
                                        :type="show ? 'text' : 'password'"
                                        :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                                        @click:append="show = !show"
                                        autocomplete="new-password"
                                        :error-messages="errors[0] ? errors[0] : errores.new_password"
                                ></v-text-field>
                            </ValidationProvider>
                            <ValidationProvider name="confirm" :rules="'required'" v-slot="{ errors }">
                                <v-text-field
                                        v-model="confirmedPassword"
                                        name="confirmedPassword"
                                        prepend-icon="mdi-lock"
                                        :type="show ? 'text' : 'password'"
                                        :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                                        @click:append="show = !show"
                                        autocomplete="new-password"
                                        :label="$t('password_new_confirm')"
                                        :error-messages="errors[0]"
                                ></v-text-field>
                            </ValidationProvider>
                            <br>
                            <v-btn
                                    color="primary"
                                    type="submit"
                                    :loading="loadingPassword"
                                    :disabled="invalid"
                            >
                                {{$t('modificar')}}
                            </v-btn>
                        </ValidationObserver>
                    </form>
                </v-card-text>
            </v-card>
        </v-layout>
        <br>
        <v-layout v-if="profileData.role === 4" align-center justify-center fill-height>
            <v-card width="500" align="center">
                <v-toolbar class="mb-5" dark color="primary">
                    <v-toolbar-title>
                        {{ $t('cambiar_wallpaper')}}
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <form @submit.prevent="changeWallpaper()">
                        <br>
                        <v-flex xs12 class="edge pt-3 pb-3 pl-3 pr-3">
                            <v-img
                                    class="pt-3 pb-3"
                                    :src="resultWallpaperURL"
                                    v-if="resultWallpaperURL"
                                    width="auto"
                                    height="180"
                            ></v-img>
                            <br>
                            <v-btn
                                    color="primary">
                                <clipper-upload
                                        @input="dialogImageWallpaper = true"
                                        accept="image/*"
                                        v-model="imageWallpaperURL"
                                >
                                    {{$t('subir_imagen')}}
                                </clipper-upload>
                            </v-btn>
                            <br>
                            <v-alert
                                    v-if="errores.wallpaper"
                                    type="error"
                                    outlined
                                    transition="scale-transition"
                            >
                                {{errores.wallpaper}}
                            </v-alert>
                        </v-flex>
                        <br>
                        <v-btn
                                color="primary"
                                :loading="loadingWallpaper"
                                type="submit"
                                :disabled="resultWallpaperURL === null || resultWallpaperURL.length < 500"
                        >
                            {{$t('modificar')}}
                        </v-btn>
                    </form>
                </v-card-text>
            </v-card>
        </v-layout>
<!--        <br>-->
<!--        <v-layout align-center justify-center fill-height>-->
<!--            <v-card width="300">-->
<!--                <v-toolbar class="mb-5" dark color="primary">-->
<!--                    <v-toolbar-title>-->
<!--                        {{ $t('notificaciones')}}-->
<!--                    </v-toolbar-title>-->
<!--                </v-toolbar>-->
<!--                <v-card-text>-->
<!--                    <form @submit.prevent="changeNotifications()">-->
<!--                        <v-switch-->
<!--                                v-model="canSMS"-->
<!--                                :label="$t('canSendSMS')">-->

<!--                        </v-switch>-->
<!--                        <v-switch-->
<!--                                v-model="canEmail"-->
<!--                                :label="$t('canSendEmail')">-->

<!--                        </v-switch>-->
<!--                        <br>-->
<!--                        <v-btn-->
<!--                                color="primary"-->
<!--                                type="submit"-->
<!--                                :disabled="invalid"-->
<!--                        >-->
<!--                            {{$t('modificar')}}-->
<!--                        </v-btn>-->
<!--                    </form>-->
<!--                </v-card-text>-->
<!--            </v-card>-->
<!--        </v-layout>-->
        <br>
        <v-layout v-show="profileData.role === 4" align-center justify-center fill-height>
            <v-card width="500">
                <v-toolbar class="mb-5" dark color="primary">
                    <v-toolbar-title>
                        {{ $t('setup_payroll_report')}}
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                  <h2>General</h2><br>
                  <v-row>
                    <v-col cols="10">
                      <v-text-field
                          type="number"
                          v-model="tolerance"
                          outlined
                          name="tolerance"
                          prepend-icon="mdi-timer"
                          :label="$t('tolerance')"
                          :error-messages="errores.tolerance"
                          autocomplete="current-password"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="2">
                      <v-btn
                          icon
                          large
                          :loading="loadingTolerance"
                          color="primary"
                          @click="changeTolerance"
                      >
                        <v-icon>
                          mdi-content-save
                        </v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="10">
                      <v-text-field
                          v-model="general_principal"
                          outlined
                          name="general_principal"
                          prepend-icon="mdi-account"
                          :label="$t('general_principal')"
                          :error-messages="errores.general_principal"
                          autocomplete="off"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="2">
                      <v-btn
                          icon
                          :loading="loadingGeneralPrincipal"
                          color="primary"
                          large
                          @click="changeGeneralPrincipal"
                      >
                        <v-icon>
                          mdi-content-save
                        </v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="8">
                      <v-layout row wrap class="text-center">
                        <v-flex class="edge pt-3 pb-3 pl-3 pr-3">
                          <v-img
                              class="pt-3 pb-3"
                              :src="resultLogoURL"
                              v-if="resultLogoURL"
                              width="auto"
                              height="180"
                          ></v-img>
                          <br>
                          <v-btn
                              color="primary">
                            <clipper-upload
                                @input="dialogImageLogo = true"
                                accept="image/*"
                                v-model="imageLogoURL"
                            >
                              {{$t('subir_imagen')}}
                            </clipper-upload>
                          </v-btn>
                          <br>
                          <v-alert
                              v-if="errores.logo"
                              type="error"
                              outlined
                              transition="scale-transition"
                          >
                            {{errores.logo}}
                          </v-alert>
                        </v-flex>
                      </v-layout>
                    </v-col>
                    <v-col cols="4">
                      <v-btn
                          color="primary"
                          :loading="loadingLogo"
                          @click="changeLogo"
                          :disabled="resultLogoURL === null || resultLogoURL.length < 500"
                      >
                        {{$t('guardar')}}
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-divider/>
                  <br><h2>{{$t('kindergarten')}}</h2><br>
                  <v-row>
                    <v-col cols="10">
                      <v-text-field
                          v-model="kindergarten_name"
                          outlined
                          name="kindergarten_name"
                          prepend-icon="mdi-town-hall"
                          :label="$t('kindergarten_name')"
                          :error-messages="errores.kindergarten_name"
                          autocomplete="off"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="2">
                      <v-btn
                          icon
                          :loading="loadingKindergartenName"
                          color="primary"
                          large
                          @click="changeKindergartenName"
                      >
                        <v-icon>
                          mdi-content-save
                        </v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="10">
                      <v-text-field
                          v-model="kindergarten_address"
                          outlined
                          name="kindergarten_address"
                          prepend-icon="mdi-map-marker"
                          :label="$t('kindergarten_address')"
                          :error-messages="errores.kindergarten_address"
                          autocomplete="off"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="2">
                      <v-btn
                          icon
                          :loading="loadingKindergartenAddress"
                          color="primary"
                          large
                          @click="changeKindergartenAddress"
                      >
                        <v-icon>
                          mdi-content-save
                        </v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="10">
                      <v-text-field
                          v-model="kindergarten_principal"
                          outlined
                          name="kindergarten_principal"
                          prepend-icon="mdi-account"
                          :label="$t('kindergarten_principal')"
                          :error-messages="errores.kindergarten_principal"
                          autocomplete="off"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="2">
                      <v-btn
                          icon
                          :loading="loadingKindergartenPrincipal"
                          color="primary"
                          large
                          @click="changeKindergartenPrincipal"
                      >
                        <v-icon>
                          mdi-content-save
                        </v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="8">
                      <v-layout row wrap class="text-center">
                        <v-flex class="edge pt-3 pb-3 pl-3 pr-3">
                          <v-img
                              class="pt-3 pb-3"
                              :src="resultLogoKinderURL"
                              v-if="resultLogoKinderURL"
                              width="auto"
                              height="180"
                          ></v-img>
                          <br>
                          <v-btn
                              color="primary">
                            <clipper-upload
                                @input="dialogImageLogoKinder = true"
                                accept="image/*"
                                v-model="imageLogoKinderURL"
                            >
                              {{$t('subir_imagen')}}
                            </clipper-upload>
                          </v-btn>
                          <br>
                          <v-alert
                              v-if="errores.logo_kindergarten"
                              type="error"
                              outlined
                              transition="scale-transition"
                          >
                            {{errores.logo_kindergarten}}
                          </v-alert>
                        </v-flex>
                      </v-layout>
                    </v-col>
                    <v-col cols="4">
                      <v-btn
                          color="primary"
                          :loading="loadingLogoKinder"
                          @click="changeLogoKinder"
                          :disabled="resultLogoKinderURL === null || resultLogoKinderURL.length < 500"
                      >
                        {{$t('guardar')}}
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-divider/>
                  <br><h2>{{$t('elementary')}}</h2><br>
                  <v-row>
                    <v-col cols="10">
                      <v-text-field
                          v-model="elementary_address"
                          outlined
                          name="elementary_address"
                          prepend-icon="mdi-map-marker"
                          :label="$t('elementary_address')"
                          :error-messages="errores.elementary_address"
                          autocomplete="off"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="2">
                      <v-btn
                          icon
                          :loading="loadingElementaryAddress"
                          color="primary"
                          large
                          @click="changeElementaryAddress"
                      >
                        <v-icon>
                          mdi-content-save
                        </v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="10">
                      <v-text-field
                          v-model="elementary_principal"
                          outlined
                          name="elementary_principal"
                          prepend-icon="mdi-account"
                          :label="$t('elementary_principal')"
                          :error-messages="errores.elementary_principal"
                          autocomplete="off"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="2">
                      <v-btn
                          icon
                          :loading="loadingElementaryPrincipal"
                          color="primary"
                          large
                          @click="changeElementaryPrincipal"
                      >
                        <v-icon>
                          mdi-content-save
                        </v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-divider/>
                  <br><h2>{{$t('middle_school')}}</h2><br>
                  <v-row>
                    <v-col cols="10">
                      <v-text-field
                          v-model="middle_school_address"
                          outlined
                          name="middle_school_address"
                          prepend-icon="mdi-map-marker"
                          :label="$t('middle_address')"
                          :error-messages="errores.middle_school_address"
                          autocomplete="off"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="2">
                      <v-btn
                          icon
                          :loading="loadingMiddleSchoolAddress"
                          color="primary"
                          large
                          @click="changeMiddleSchoolAddress"
                      >
                        <v-icon>
                          mdi-content-save
                        </v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="10">
                      <v-text-field
                          v-model="middle_school_principal"
                          outlined
                          name="middle_school_principal"
                          prepend-icon="mdi-account"
                          :label="$t('middle_school_principal')"
                          :error-messages="errores.middle_school_principal"
                          autocomplete="off"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="2">
                      <v-btn
                          icon
                          :loading="loadingMiddleSchoolPrincipal"
                          color="primary"
                          large
                          @click="changeMiddleSchoolPrincipal"
                      >
                        <v-icon>
                          mdi-content-save
                        </v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-divider/>
                  <br><h2>{{$t('high_school')}}</h2><br>
                  <v-row>
                    <v-col cols="10">
                      <v-text-field
                          v-model="high_school_address"
                          outlined
                          name="high_school_address"
                          prepend-icon="mdi-map-marker"
                          :label="$t('high_address')"
                          :error-messages="errores.high_school_address"
                          autocomplete="off"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="2">
                      <v-btn
                          icon
                          :loading="loadingHighSchoolAddress"
                          color="primary"
                          large
                          @click="changeHighSchoolAddress"
                      >
                        <v-icon>
                          mdi-content-save
                        </v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="10">
                      <v-text-field
                          v-model="high_school_principal"
                          outlined
                          name="high_school_principal"
                          prepend-icon="mdi-account"
                          :label="$t('high_school_principal')"
                          :error-messages="errores.high_school_principal"
                          autocomplete="off"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="2">
                      <v-btn
                          icon
                          :loading="loadingHighSchoolPrincipal"
                          color="primary"
                          large
                          @click="changeHighSchoolPrincipal"
                      >
                        <v-icon>
                          mdi-content-save
                        </v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-divider/>
                  <br><h2>{{$t('health_format')}}</h2><br>
                  <v-row>
                    <v-col cols="10">
                      <v-switch
                          v-model="enable_health_form"
                          outlined
                          :loading="loadingEnableHealthForm"
                          name="enable_health_form"
                          prepend-icon="mdi-virus-outline"
                          @change="changeEnableHealthForm"
                          :label="enable_health_form ? $t('enabled'): $t('disabled')"
                          :error-messages="errores.enable_health_form"
                          autocomplete="off"
                      ></v-switch>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="10">
                      <v-textarea
                          v-model="healthy_format_text"
                          outlined
                          name="healthy_format_text"
                          prepend-icon="mdi-text"
                          :label="$t('health_format') + ' (' + $t('spanish') + ')'"
                          :error-messages="errores.healthy_format_text"
                          autocomplete="off"
                      ></v-textarea>
                    </v-col>
                    <v-col cols="2">
                      <v-btn
                          icon
                          :loading="loadingHealthyFormatText"
                          color="primary"
                          large
                          @click="changeHealthyFormatText"
                      >
                        <v-icon>
                          mdi-content-save
                        </v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="10">
                      <v-textarea
                          v-model="healthy_format_text_en"
                          outlined
                          name="healthy_format_text_en"
                          prepend-icon="mdi-text"
                          :label="$t('health_format') + ' (' + $t('english') + ')'"
                          :error-messages="errores.healthy_format_text_en"
                          autocomplete="off"
                      ></v-textarea>
                    </v-col>
                    <v-col cols="2">
                      <v-btn
                          icon
                          :loading="loadingHealthyFormatTextEn"
                          color="primary"
                          large
                          @click="changeHealthyFormatTextEn"
                      >
                        <v-icon>
                          mdi-content-save
                        </v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
            </v-card>
        </v-layout>
    </v-container>
</template>

<script>
import {HTTP} from '@/main.js'
import store from '@/store'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import Vue from 'vue'
import VuejsClipper from 'vuejs-clipper'
import {mapGetters} from "vuex"

extend('password', {
  params: ['target'],
  validate (value, { target }) {
    return value === target
  },
  message: 'Password confirmation does not match'
})

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
Vue.use(VuejsClipper, {
  components: {
    clipperBasic: 'clipper-basic',
    clipperFixed: 'clipper-fixed',
    clipperUpload: 'clipper-upload'
  }
})
export default {
  name: 'settings',
  data: () => ({
    currentPassword: '',
    password: '',
    confirmedPassword: '',
    errores: [],
    show: false,
    profileData: {},
    canSMS: null,
    canEmail: null,
    loadingPassword: false,
    loadingWallpaper: false,
    loadingLogoKinder: false,
    loadingLogo: false,
    loadingTolerance: false,
    loadingGeneralPrincipal: false,
    loadingKindergartenName: false,
    loadingKindergartenAddress: false,
    loadingKindergartenPrincipal: false,
    loadingElementaryAddress: false,
    loadingElementaryPrincipal: false,
    loadingMiddleSchoolAddress: false,
    loadingMiddleSchoolPrincipal: false,
    loadingHighSchoolAddress: false,
    loadingEnableHealthForm: false,
    loadingHighSchoolPrincipal: false,
    loadingHealthyFormatText: false,
    loadingHealthyFormatTextEn: false,
    dialogImageWallpaper: false,
    imageWallpaperURL: '',
    resultWallpaperURL: '',
    dialogImageLogoKinder: false,
    imageLogoKinderURL: '',
    resultLogoKinderURL: '',
    dialogImageLogo: false,
    imageLogoURL: '',
    resultLogoURL: '',
    tolerance: 1,
    kindergarten_address: null,
    kindergarten_principal: null,
    general_principal: null,
    kindergarten_name: null,
    elementary_address: null,
    elementary_principal: null,
    middle_school_address: null,
    middle_school_principal: null,
    high_school_address: null,
    enable_health_form: null,
    high_school_principal: null,
    healthy_format_text: null,
    healthy_format_text_en: null,
  }),
  computed: {
    ...mapGetters(['getProfile']),
  },
  created () {
    this.getProfileData()
  },
  methods: {
    changePassword () {
      this.errores = []
      this.loadingPassword = true
      HTTP.patch('users/change_password/', {
        current_password: this.currentPassword,
        new_password: this.password
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(ok => {
        console.log(ok)
        this.loadingPassword = false
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_message', this.$t('msg_cambio_password'))
        setTimeout(this.clearNoImage, 3000)
      })
      .catch(error => {
        this.loadingPassword = false
        if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
          if (error.response.data.non_field_errors) {
            this.errores.new_password = []
            for (var i = 0; i < error.response.data.non_field_errors.length ; i++) {
              this.errores.new_password += error.response.data.non_field_errors[i]
            }
          }
          else {
            this.errores = error.response.data
          }
        }
      })
    },
    changeWallpaper () {
      this.errores = []
      this.loadingWallpaper = true
      var bodyFormData = new FormData()
      var fileImageFront = null
      const newID = this.$uuid.v4()
      if (this.resultWallpaperURL !== '' && this.resultWallpaperURL.length > 6) {
        fileImageFront = this.dataURLtoFile(this.resultWallpaperURL, 'wallpaper_update' + newID + '.jpeg')
      }
      bodyFormData.append('wallpaper', fileImageFront)
      HTTP.patch('school/' +  this.profileData.idSchool, bodyFormData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(ok => {
        console.log(ok)
        this.loadingWallpaper = false
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_message', this.$t('cambiar_wallpaper_exito'))
        this.getProfileData()
        setTimeout(this.clearNoImage, 3000)
      })
      .catch(error => {
        this.loadingWallpaper = false
        if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
          this.errores = error.response.data
        }
      })
    },
    changeLogoKinder () {
      this.errores = []
      this.loadingLogoKinder = true
      var bodyFormData = new FormData()
      var fileImageFront = null
      const newID = this.$uuid.v4()
      if (this.resultLogoKinderURL !== '' && this.resultLogoKinderURL.length > 6) {
        fileImageFront = this.dataURLtoFile(this.resultLogoKinderURL, 'logo_kinder_update' + newID + '.jpeg')
      }
      bodyFormData.append('logo_kindergarten', fileImageFront)
      HTTP.patch('school/' +  this.profileData.idSchool, bodyFormData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(ok => {
        console.log(ok)
        this.loadingLogoKinder = false
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_message', this.$t('change_item_success'))
        this.getProfileData()
        setTimeout(this.clearNoImage, 3000)
      })
      .catch(error => {
        this.loadingLogoKinder = false
        if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
          this.errores = error.response.data
        }
      })
    },
    changeLogo () {
      this.errores = []
      this.loadingLogo = true
      var bodyFormData = new FormData()
      var fileImageFront = null
      const newID = this.$uuid.v4()
      if (this.resultLogoURL !== '' && this.resultLogoURL.length > 6) {
        fileImageFront = this.dataURLtoFile(this.resultLogoURL, 'logo_update' + newID + '.jpeg')
      }
      bodyFormData.append('logo', fileImageFront)
      HTTP.patch('school/' +  this.profileData.idSchool, bodyFormData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(ok => {
        console.log(ok)
        this.loadingLogo = false
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_message', this.$t('change_item_success'))
        this.getProfileData()
        setTimeout(this.clearNoImage, 3000)
      })
      .catch(error => {
        this.loadingLogo = false
        if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
          this.errores = error.response.data
        }
      })
    },
    changeTolerance () {
      this.errores = []
      this.loadingTolerance = true
      HTTP.patch('school/' +  this.profileData.idSchool,
          {
            tolerance: this.tolerance
          },
          {
            headers: {
              'Content-Type': 'application/json',
              'Accept-Language': this.language,
              'authorization': 'Token ' + store.getters.getToken
            }
          })
          .then(ok => {
            console.log(ok)
            this.loadingTolerance = false
            this.$store.commit('snackbar_activate_true')
            this.$store.commit('snackbar_change_message', this.$t('change_item_success'))
            this.getProfileData()
            setTimeout(this.clearNoImage, 3000)
          })
          .catch(error => {
            this.loadingTolerance = false
            if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
              this.errores = error.response.data
            }
          })
    },
    changeKindergartenName () {
      this.errores = []
      this.loadingKindergartenName = true
      HTTP.patch('school/' +  this.profileData.idSchool,
          {
            kindergarten_name: this.kindergarten_name
          },
          {
            headers: {
              'Content-Type': 'application/json',
              'Accept-Language': this.language,
              'authorization': 'Token ' + store.getters.getToken
            }
          })
          .then(ok => {
            console.log(ok)
            this.loadingKindergartenName = false
            this.$store.commit('snackbar_activate_true')
            this.$store.commit('snackbar_change_message', this.$t('change_item_success'))
            this.getProfileData()
            setTimeout(this.clearNoImage, 3000)
          })
          .catch(error => {
            this.loadingKindergartenName = false
            if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
              this.errores = error.response.data
            }
          })
    },
    changeKindergartenAddress () {
      this.errores = []
      this.loadingKindergartenAddress = true
      HTTP.patch('school/' +  this.profileData.idSchool,
          {
            kindergarten_address: this.kindergarten_address
          },
          {
            headers: {
              'Content-Type': 'application/json',
              'Accept-Language': this.language,
              'authorization': 'Token ' + store.getters.getToken
            }
          })
          .then(ok => {
            console.log(ok)
            this.loadingKindergartenAddress = false
            this.$store.commit('snackbar_activate_true')
            this.$store.commit('snackbar_change_message', this.$t('change_item_success'))
            this.getProfileData()
            setTimeout(this.clearNoImage, 3000)
          })
          .catch(error => {
            this.loadingKindergartenAddress = false
            if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
              this.errores = error.response.data
            }
          })
    },
    changeElementaryPrincipal () {
      this.errores = []
      this.loadingElementaryPrincipal = true
      HTTP.patch('school/' +  this.profileData.idSchool,
          {
            elementary_principal: this.elementary_principal
          },
          {
            headers: {
              'Content-Type': 'application/json',
              'Accept-Language': this.language,
              'authorization': 'Token ' + store.getters.getToken
            }
          })
          .then(ok => {
            console.log(ok)
            this.loadingElementaryPrincipal = false
            this.$store.commit('snackbar_activate_true')
            this.$store.commit('snackbar_change_message', this.$t('change_item_success'))
            this.getProfileData()
            setTimeout(this.clearNoImage, 3000)
          })
          .catch(error => {
            this.loadingElementaryPrincipal = false
            if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
              this.errores = error.response.data
            }
          })
    },
    changeGeneralPrincipal () {
      this.errores = []
      this.loadingGeneralPrincipal = true
      HTTP.patch('school/' +  this.profileData.idSchool,
          {
            general_principal: this.general_principal
          },
          {
            headers: {
              'Content-Type': 'application/json',
              'Accept-Language': this.language,
              'authorization': 'Token ' + store.getters.getToken
            }
          })
          .then(ok => {
            console.log(ok)
            this.loadingGeneralPrincipal = false
            this.$store.commit('snackbar_activate_true')
            this.$store.commit('snackbar_change_message', this.$t('change_item_success'))
            this.getProfileData()
            setTimeout(this.clearNoImage, 3000)
          })
          .catch(error => {
            this.loadingGeneralPrincipal = false
            if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
              this.errores = error.response.data
            }
          })
    },
    changeKindergartenPrincipal () {
      this.errores = []
      this.loadingKindergartenPrincipal = true
      HTTP.patch('school/' +  this.profileData.idSchool,
          {
            kindergarten_principal: this.kindergarten_principal
          },
          {
            headers: {
              'Content-Type': 'application/json',
              'Accept-Language': this.language,
              'authorization': 'Token ' + store.getters.getToken
            }
          })
          .then(ok => {
            console.log(ok)
            this.loadingKindergartenPrincipal = false
            this.$store.commit('snackbar_activate_true')
            this.$store.commit('snackbar_change_message', this.$t('change_item_success'))
            this.getProfileData()
            setTimeout(this.clearNoImage, 3000)
          })
          .catch(error => {
            this.loadingKindergartenPrincipal = false
            if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
              this.errores = error.response.data
            }
          })
    },
    changeElementaryAddress () {
      this.errores = []
      this.loadingElementaryAddress = true
      HTTP.patch('school/' +  this.profileData.idSchool,
          {
            elementary_address: this.elementary_address
          },
          {
            headers: {
              'Content-Type': 'application/json',
              'Accept-Language': this.language,
              'authorization': 'Token ' + store.getters.getToken
            }
          })
          .then(ok => {
            console.log(ok)
            this.loadingElementaryAddress = false
            this.$store.commit('snackbar_activate_true')
            this.$store.commit('snackbar_change_message', this.$t('change_item_success'))
            this.getProfileData()
            setTimeout(this.clearNoImage, 3000)
          })
          .catch(error => {
            this.loadingElementaryAddress = false
            if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
              this.errores = error.response.data
            }
          })
    },
    changeMiddleSchoolAddress () {
      this.errores = []
      this.loadingMiddleSchoolAddress = true
      HTTP.patch('school/' +  this.profileData.idSchool,
          {
            middle_school_address: this.middle_school_address
          },
          {
            headers: {
              'Content-Type': 'application/json',
              'Accept-Language': this.language,
              'authorization': 'Token ' + store.getters.getToken
            }
          })
          .then(ok => {
            console.log(ok)
            this.loadingMiddleSchoolAddress = false
            this.$store.commit('snackbar_activate_true')
            this.$store.commit('snackbar_change_message', this.$t('change_item_success'))
            this.getProfileData()
            setTimeout(this.clearNoImage, 3000)
          })
          .catch(error => {
            this.loadingMiddleSchoolAddress = false
            if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
              this.errores = error.response.data
            }
          })
    },
    changeMiddleSchoolPrincipal () {
      this.errores = []
      this.loadingMiddleSchoolPrincipal = true
      HTTP.patch('school/' +  this.profileData.idSchool,
          {
            middle_school_principal: this.middle_school_principal
          },
          {
            headers: {
              'Content-Type': 'application/json',
              'Accept-Language': this.language,
              'authorization': 'Token ' + store.getters.getToken
            }
          })
          .then(ok => {
            console.log(ok)
            this.loadingMiddleSchoolPrincipal = false
            this.$store.commit('snackbar_activate_true')
            this.$store.commit('snackbar_change_message', this.$t('change_item_success'))
            this.getProfileData()
            setTimeout(this.clearNoImage, 3000)
          })
          .catch(error => {
            this.loadingMiddleSchoolPrincipal = false
            if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
              this.errores = error.response.data
            }
          })
    },
    changeHighSchoolPrincipal () {
      this.errores = []
      this.loadingHighSchoolPrincipal = true
      HTTP.patch('school/' +  this.profileData.idSchool,
          {
            high_school_principal: this.high_school_principal
          },
          {
            headers: {
              'Content-Type': 'application/json',
              'Accept-Language': this.language,
              'authorization': 'Token ' + store.getters.getToken
            }
          })
          .then(ok => {
            console.log(ok)
            this.loadingHighSchoolPrincipal = false
            this.$store.commit('snackbar_activate_true')
            this.$store.commit('snackbar_change_message', this.$t('change_item_success'))
            this.getProfileData()
            setTimeout(this.clearNoImage, 3000)
          })
          .catch(error => {
            this.loadingHighSchoolPrincipal = false
            if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
              this.errores = error.response.data
            }
          })
    },
    changeHighSchoolAddress () {
      this.errores = []
      this.loadingHighSchoolAddress = true
      HTTP.patch('school/' +  this.profileData.idSchool,
          {
            high_school_address: this.high_school_address
          },
          {
            headers: {
              'Content-Type': 'application/json',
              'Accept-Language': this.language,
              'authorization': 'Token ' + store.getters.getToken
            }
          })
          .then(ok => {
            console.log(ok)
            this.loadingHighSchoolAddress = false
            this.$store.commit('snackbar_activate_true')
            this.$store.commit('snackbar_change_message', this.$t('change_item_success'))
            this.getProfileData()
            setTimeout(this.clearNoImage, 3000)
          })
          .catch(error => {
            this.loadingHighSchoolAddress = false
            if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
              this.errores = error.response.data
            }
          })
    },
    changeEnableHealthForm () {
      this.errores = []
      this.loadingEnableHealthForm = true
      HTTP.patch('school/' +  this.profileData.idSchool,
          {
            enable_health_form: this.enable_health_form
          },
          {
            headers: {
              'Content-Type': 'application/json',
              'Accept-Language': this.language,
              'authorization': 'Token ' + store.getters.getToken
            }
          })
          .then(ok => {
            console.log(ok)
            this.loadingEnableHealthForm = false
            this.$store.commit('snackbar_activate_true')
            this.$store.commit('snackbar_change_message', this.$t('change_item_success'))
            this.getProfileData()
            setTimeout(this.clearNoImage, 3000)
          })
          .catch(error => {
            this.loadingEnableHealthForm = false
            if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
              this.errores = error.response.data
            }
          })
    },
    changeHealthyFormatText () {
      this.errores = []
      this.loadingHealthyFormatText = true
      HTTP.patch('school/' +  this.profileData.idSchool,
          {
            healthy_format_text: this.healthy_format_text
          },
          {
            headers: {
              'Content-Type': 'application/json',
              'Accept-Language': this.language,
              'authorization': 'Token ' + store.getters.getToken
            }
          })
          .then(ok => {
            console.log(ok)
            this.loadingHealthyFormatText = false
            this.$store.commit('snackbar_activate_true')
            this.$store.commit('snackbar_change_message', this.$t('change_item_success'))
            this.getProfileData()
            setTimeout(this.clearNoImage, 3000)
          })
          .catch(error => {
            this.loadingHealthyFormatText = false
            if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
              this.errores = error.response.data
            }
          })
    },
    changeHealthyFormatTextEn () {
      this.errores = []
      this.loadingHealthyFormatTextEn = true
      HTTP.patch('school/' +  this.profileData.idSchool,
          {
            healthy_format_text_en: this.healthy_format_text_en
          },
          {
            headers: {
              'Content-Type': 'application/json',
              'Accept-Language': this.language,
              'authorization': 'Token ' + store.getters.getToken
            }
          })
          .then(ok => {
            console.log(ok)
            this.loadingHealthyFormatTextEn = false
            this.$store.commit('snackbar_activate_true')
            this.$store.commit('snackbar_change_message', this.$t('change_item_success'))
            this.getProfileData()
            setTimeout(this.clearNoImage, 3000)
          })
          .catch(error => {
            this.loadingHealthyFormatTextEn = false
            if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
              this.errores = error.response.data
            }
          })
    },
    clear () {
      this.$refs.observer.reset()
      this.cleanFields()
      this.errores = []
      this.$store.commit('snackbar_activate_false')
    },
    clearNoImage () {
      this.$refs.observer.reset()
      this.cleanFieldsNoImage()
      this.errores = []
      this.$store.commit('snackbar_activate_false')
    },
    cleanFields () {
      this.resultWallpaperURL = ''
      this.resultLogoURL = ''
      this.resultLogoKinderURL = ''
      this.currentPassword = ''
      this.password = ''
      this.confirmedPassword = ''
    },
    cleanFieldsNoImage () {
      this.currentPassword = ''
      this.password = ''
      this.confirmedPassword = ''
    },
    getProfileData () {
      HTTP.get('api/users/me/', {
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(response => {
        this.profileData = response.data
        this.resultWallpaperURL = response.data.wallpaper
        this.canSMS = this.profileData.can_sms
        this.canEmail = this.profileData.can_email
        this.getSchoolData()
      })
      .catch(error => {
        console.log(error)
      })
    },
    getSchoolData () {
      HTTP.get('school/' + this.getProfile.idSchool, {
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(response => {
        this.tolerance = response.data.tolerance
        this.general_principal = response.data.general_principal
        this.kindergarten_name = response.data.kindergarten_name
        this.kindergarten_address = response.data.kindergarten_address
        this.kindergarten_principal = response.data.kindergarten_principal
        this.elementary_principal = response.data.elementary_principal
        this.elementary_address = response.data.elementary_address
        this.middle_school_address = response.data.middle_school_address
        this.middle_school_principal = response.data.middle_school_principal
        this.high_school_address = response.data.high_school_address
        this.enable_health_form = response.data.enable_health_form
        this.healthy_format_text = response.data.healthy_format_text
        this.healthy_format_text_en = response.data.healthy_format_text_en
        this.high_school_principal = response.data.high_school_principal
        this.resultLogoURL = response.data.logo
        this.resultLogoKinderURL = response.data.logo_kindergarten
        console.log('Toleracncia = ', this.tolerance)
      })
      .catch(error => {
        console.log(error)
      })
    },
    changeNotifications () {
      HTTP.patch('auth/users/' + this.profileData.id + '/', {
        'can_sms': this.canSMS,
        'can_email': this.canEmail
      }, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(ok => {
        console.log(ok)
        this.getProfileData()
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_message', this.$t('notificacion_success'))
        setTimeout(this.clear, 3000)
      })
      .catch(error => {
        if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
          this.errores = error.response.data
        }
      })
    },
    getCutingWallpaper () {
      const canvas = this.$refs.clipperImageWallpaper.clip() // call component's clip method
      this.resultWallpaperURL = canvas.toDataURL('image/jpeg', 0.2) // canvas->image
      this.dialogImageWallpaper = false
    },
    getCutingLogo () {
      const canvas = this.$refs.clipperImageLogo.clip() // call component's clip method
      this.resultLogoURL = canvas.toDataURL('image/jpeg', 0.2) // canvas->image
      this.dialogImageLogo = false
    },
    getCutingLogoKinder () {
      const canvas = this.$refs.clipperImageLogoKinder.clip() // call component's clip method
      this.resultLogoKinderURL = canvas.toDataURL('image/jpeg', 0.2) // canvas->image
      this.dialogImageLogoKinder = false
    },
    dataURLtoFile (dataurl, filename) {
      var arr = dataurl.split(',')
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    }
  }
}
</script>

<style scoped>
    .edge {
        border-radius: 8px;
        border-color: #00A1E4 #00A1E4 #00A1E4 #00A1E4;
        border-width: 3px 3px 3px 3px;
        border-style: solid solid solid solid;
    }
    .wrapper img{
        position: relative;
        width:100%;
        height:auto;
    }
</style>
